module.exports = __webpack_public_path__ + "img/carpenter.0dd973f3.jpg";